// Material Dashboard 2 React components
import MDBox from "components/MDBox"
// Configuraciones page components
import ConfiguracionItem from "layouts/asistencia/configuraciones/components/ConfiguracionItem"
import PropTypes from "prop-types"

function ConfiguracionesInformation({ configuraciones, onReload }) {
  return (
    <MDBox pt={1} pb={2} px={2}>
      {configuraciones?.map((item) => (
        <div key={item.id}>
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
            <ConfiguracionItem
              key={item.id}
              id={item.id}
              dependenciaNombre={item.dependenciaNombre}
              tipoAsistenteNombre={item.tipoAsistenteNombre}
              diaSemana={item.diaSemana}
              horaEntradaEsperada={item.horaEntradaEsperada}
              horaSalidaEsperada={item.horaSalidaEsperada}
              minutosToleranciaEntrada={item.minutosToleranciaEntrada}
              minutosToleranciaSalida={item.minutosToleranciaSalida}
              activo={item.activo}
              onReload={onReload}
            />
          </MDBox>
          <hr></hr>
        </div>
      ))}
    </MDBox>
  )
}

ConfiguracionesInformation.propTypes = {
  configuraciones: PropTypes.arrayOf(PropTypes.object).isRequired,
  onReload: PropTypes.func.isRequired,
}

export default ConfiguracionesInformation
